export interface Reward {
  type: RewardType;
  amount: number;
  innerRewards: Reward[];
}

export enum RewardType {
  Credits = 0,
  Postcard = 1,
  GiftBox = 2,
  RandomBooster = 3,
  TargetBooster = 4,
  ChallengeBooster = 5,
}

export const RewardTypeLabels: Record<RewardType, string> = {
  [RewardType.Credits]: 'Credits',
  [RewardType.Postcard]: 'Postcard',
  [RewardType.GiftBox]: 'GiftBox',
  [RewardType.RandomBooster]: 'RandomBooster',
  [RewardType.TargetBooster]: 'TargetBooster',
  [RewardType.ChallengeBooster]: 'ChallengeBooster',
};

export const AvailableRewardTypes = [
  RewardType.Credits,
  RewardType.RandomBooster,
  RewardType.TargetBooster,
  RewardType.ChallengeBooster,
];
